import { createSlice } from '@reduxjs/toolkit';

const initialState = {
 userListData:[], 
 userDetailsData:[]
};

const userListSlice = createSlice({
  name: 'rolesDetails',
  initialState,
  reducers: {
    saveUsersListData: (state, action) => {
      state.userListData = action.payload;
    },
    saveUserDetailsData: (state, action) => {
      state.userDetailsData = action.payload;
    },
    
  },
});

export const { saveUsersListData ,saveUserDetailsData} = userListSlice.actions;

export default userListSlice.reducer;
